import { render, staticRenderFns } from "./chuxian.vue?vue&type=template&id=72199249&scoped=true&"
import script from "./chuxian.vue?vue&type=script&lang=js&"
export * from "./chuxian.vue?vue&type=script&lang=js&"
import style0 from "./chuxian.vue?vue&type=style&index=0&id=72199249&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72199249",
  null
  
)

export default component.exports